import PropTypes from 'prop-types';
import styles from './FJClothesChangerStyleList.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import ArrowIcon from '../../../assets/svg/catalog-right.svg?react';

import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJStyleItem from '../FJStyleItem/FJStyleItem';
import FJConfig from '../../../config/FJConfig';
import { useState } from 'react';
import classNames from 'classnames';
const FJClothesChangerStyleList = props => {
    const { list, selectedName, onChange } = props;
    // TODO see all
    const [isSeeAll, setIsSeeAll] = useState(false);
    const [seeAllInfo, setSeeAllInfo] = useState(null);
    const _seeAll = list => {
        setIsSeeAll(true);
        setSeeAllInfo(list);
    };
    const _gotoBack = () => {
        setIsSeeAll(false);
    };
    const _getImageUrl = name => {
        return FJConfig.stylePath + name + `?v=${FJConfig.version}`;
    };

    const _onSelect = (item, applyDoneCallback) => {
        if (onChange) onChange(item.name, _getImageUrl(item.img), applyDoneCallback);
    };

    const renderList = () => {
        return (
            <FJVerticalScroller className={styles.box} style={{ display: !isSeeAll ? 'block' : 'none' }}>
                {list.map(category => (
                    <div key={category.categoryName} className={styles.category_box}>
                        <div className={styles.category_header}>
                            <div className={styles.header_left}>
                                <span className={styles.category_name}>{FJLocalStore._(category.categoryName)}</span>
                            </div>
                            {list.length > 4 && (
                                <div className={styles.see_all} onClick={() => _seeAll(category)}>
                                    {FJLocalStore._('see-all')}
                                </div>
                            )}
                        </div>
                        <div className={styles.category_content}>
                            {category.list.slice(0, 4).map((item, index) => (
                                <FJStyleItem
                                    key={item.name + index}
                                    imgSrc={_getImageUrl(item.img)}
                                    name={FJLocalStore._(item.name)}
                                    selected={item.name === selectedName}
                                    onClick={applyDoneCallback => {
                                        _onSelect(item, applyDoneCallback);
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </FJVerticalScroller>
        );
    };

    const renderSeeAll = () => {
        if (!seeAllInfo) return null;
        const { list = [], categoryName } = seeAllInfo;
        return (
            <div className={classNames(styles.see_all_box)} style={{ display: isSeeAll ? 'block' : 'none' }}>
                <div className={styles.see_all_header}>
                    <div className={styles.see_all_back} onClick={_gotoBack}>
                        <ArrowIcon className={styles.see_all_back_icon} />
                    </div>
                    <span className={styles.see_all_title}>{FJLocalStore._(categoryName)}</span>
                </div>
                <FJVerticalScroller className={classNames(styles.box, styles.see_all_scroll)}>
                    <div className={styles.see_all_content}>
                        {list.map((item, index) => (
                            <FJStyleItem
                                key={item.name + index}
                                imgSrc={_getImageUrl(item.img)}
                                name={FJLocalStore._(item.name)}
                                selected={item.name === selectedName}
                                onClick={applyDoneCallback => {
                                    _onSelect(item, applyDoneCallback);
                                }}
                            />
                        ))}
                    </div>
                </FJVerticalScroller>
            </div>
        );
    };

    return (
        <>
            {renderSeeAll()}
            {renderList()}
        </>
    );
};
FJClothesChangerStyleList.propTypes = {
    list: PropTypes.array,
    selectedName: PropTypes.string,
    onChange: PropTypes.func,
};
export default FJClothesChangerStyleList;
